import { Empty, Loading, Mail, useAdminList, when } from "./shared";

export const MessagesTab = () => {
  const { items } = useAdminList("/admin/messages");
  if (!items) return <Loading />;
  if (!items.length) return <Empty testId="messages-empty">No notes yet.</Empty>;
  return (
    <ul className="grid gap-4" data-testid="admin-messages-list">
      {items.map((m) => (
        <li key={m.id} className="bg-paper rounded-2xl p-6" data-testid={`admin-message-${m.id}`}>
          <div className="flex flex-wrap justify-between gap-2">
            <p className="font-medium">{m.name} · <span className="font-normal text-sm"><Mail to={m.email} /></span></p>
            <p className="text-sm text-moss">{when(m.created_at)}</p>
          </div>
          <p className="mt-3 whitespace-pre-line">{m.message}</p>
        </li>
      ))}
    </ul>
  );
};

export const ReservationsTab = () => {
  const { items } = useAdminList("/admin/reservations");
  if (!items) return <Loading />;
  if (!items.length) return <Empty testId="reservations-empty">No retreat reservations yet.</Empty>;
  return (
    <ul className="grid gap-4" data-testid="admin-reservations-list">
      {items.map((r) => (
        <li key={r.id} className="bg-paper rounded-2xl p-6 grid sm:grid-cols-[1fr_auto] gap-2" data-testid={`admin-reservation-${r.id}`}>
          <div className="min-w-0">
            <p className="lb text-brass-ink">{r.retreat_title}</p>
            <p className="mt-2 font-medium">{r.name} · {r.seats} {r.seats === 1 ? "seat" : "seats"}</p>
            <p className="text-sm"><Mail to={r.email} />{r.phone && <> · <a href={`tel:${r.phone}`} className="underline underline-offset-4 decoration-brass">{r.phone}</a></>}</p>
            {r.note && <p className="mt-2 text-sm text-moss whitespace-pre-line">{r.note}</p>}
          </div>
          <p className="text-sm text-moss">{when(r.created_at)}</p>
        </li>
      ))}
    </ul>
  );
};

const LABEL = { monthly: "Monthly", one_time: "One-time" };

export const GiftsTab = () => {
  const { items } = useAdminList("/admin/gifts");
  if (!items) return <Loading />;
  if (!items.length) return <Empty testId="gifts-empty">No completed gifts yet.</Empty>;
  const total = items.reduce((s, g) => s + (g.amount || 0), 0) / 100;
  return (
    <div data-testid="admin-gifts">
      <p className="mb-6 text-moss">Total received: <span className="dp text-3xl text-pine tn" data-testid="gifts-total">${total.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span></p>
      <ul className="grid gap-3">
        {items.map((g) => (
          <li key={g.session_id} className="bg-paper rounded-2xl px-6 py-4 flex justify-between gap-4 tn" data-testid={`admin-gift-${g.session_id}`}>
            <span>${((g.amount || 0) / 100).toFixed(2)} · {LABEL[g.mode] || "One-time"}</span>
            <span className="text-sm text-moss">{when(g.created_at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
